import type { IObjectWithTypename } from "@/components/@types";
import { useNode, useNodeSetup } from "@/components/organisms/Node/Node.hooks";
import { NodeTitleLayout } from "@/components/organisms/Node/NodeTitleLayout";
import { StickyLayout } from "@/components/organisms/StickyLayout";
import { usePageThreadReference } from "@/components/organisms/Thread/Thread.hooks";

import { useRuleEditorState } from "./RuleDetailPage.hooks";
import { RuleEditor } from "./RuleEditor";
import { useRuleEditorStore } from "./ruleEditorStore";

function RulesEditorInner() {
  useRuleEditorState();
  const rule = useRuleEditorStore((state) => state.rule);
  // The rule open here goes to the chat as the page's, for as long as it is
  // open - as a record's own page does.
  usePageThreadReference(
    rule
      ? {
          id: rule.id,
          identifier: rule.identifier,
          name: rule.name || "Untitled rule",
          typename: "RuleDefinitionObject",
        }
      : null,
  );
  // The title bar a record's own page has - the rule's name and its actions,
  // as its side panel shows them - over a store the loaded rule fills.
  const { store } = useNodeSetup({
    mode: "update",
    node: (rule ?? undefined) as unknown as IObjectWithTypename,
    typename: "RuleDefinitionObject",
  });
  const { actions, metadata } = useNode(store);
  return (
    <div className="h-full w-full bg-background">
      <StickyLayout
        stickyTopChildren={
          <NodeTitleLayout
            store={store}
            title={metadata.title}
            isLoading={!rule}
            actions={actions}
          />
        }
        stickyTopClassName="[border-bottom-width:1px] [border-bottom-style:solid] border-border"
      >
        <div className="w-full flex-1 min-h-0 relative overflow-hidden">
          <RuleEditor />
        </div>
      </StickyLayout>
    </div>
  );
}

export default function RuleDetailPage() {
  return <RulesEditorInner />;
}
